module.exports = __webpack_public_path__ + "img/535-354fc0.png";